export default __webpack_public_path__ + "static/foreldre-veileder-e67b570475b40d683a21c7226e187e8a.png";